
import { HuntrixSong } from './types';

export const GOLDEN: HuntrixSong = {
    id: 'GOLDEN',
    title: "Golden",
    artist: "HUNTR/X",
    midiFileName: "Golden.mid",
    mp3FileName: "Golden.mp3",
    // Embedded sequenced tracks as a primary source to avoid 404s
    sequencedTracks: [
        {
            "name": "Synthesizer",
            "notes": [
                {
                    "name": "E3",
                    "duration": "2n",
                    "time": "0:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "2n",
                    "time": "0:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "0:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "0:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "2n",
                    "time": "0:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "2n",
                    "time": "0:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "2n",
                    "time": "1:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "2n",
                    "time": "1:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "2n",
                    "time": "1:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "2n",
                    "time": "2:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "2:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "2n",
                    "time": "2:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "2n",
                    "time": "3:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "2n",
                    "time": "3:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "3:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "3:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "2n",
                    "time": "3:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "2n",
                    "time": "3:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "2n",
                    "time": "4:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "2n",
                    "time": "4:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "2n",
                    "time": "4:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "2n",
                    "time": "87:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "2n",
                    "time": "87:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "87:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "87:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "2n",
                    "time": "87:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "2n",
                    "time": "87:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "2n",
                    "time": "88:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "2n",
                    "time": "88:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "2n",
                    "time": "88:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "2n",
                    "time": "89:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "89:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "2n",
                    "time": "89:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "2n",
                    "time": "90:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "2n",
                    "time": "90:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "90:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "90:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "2n",
                    "time": "90:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "2n",
                    "time": "90:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "2n",
                    "time": "91:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "2n",
                    "time": "91:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "2n",
                    "time": "91:2:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Synth Pluck",
            "notes": [
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "0:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "0:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "0:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "0:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "0:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "0:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "0:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "0:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "0:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "0:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "0:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "1:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "1:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "1:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "1:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "1:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "1:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "1:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "1:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "1:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "1:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "1:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "2:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "2:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "2:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "2:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "2:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "2:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "2:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "2:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "2:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "2:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "3:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "3:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "3:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "3:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "3:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "3:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "3:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "3:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "3:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "3:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "3:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "4:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "4:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "4:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "4:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "4:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "4:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "4:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "4:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "4:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "4:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "4:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "5:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "5:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "87:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "87:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "87:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "87:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "87:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "87:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "87:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "87:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "87:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "87:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "87:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "88:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "88:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "88:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "88:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "88:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "88:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "88:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "88:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "88:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "88:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "88:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "89:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "89:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "89:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "89:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "89:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "89:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "89:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "89:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "89:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "89:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "90:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "90:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "90:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "90:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "90:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "90:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "90:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "90:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "90:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "90:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "90:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "91:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "91:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "91:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "91:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "91:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "91:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "91:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "91:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "91:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "91:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "91:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "92:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "92:0:2",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "8-Bit Sawtooth",
            "notes": [
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "3:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "E3",
                    "duration": "2n",
                    "time": "3:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "C3",
                    "duration": "2n",
                    "time": "3:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "3:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D3",
                    "duration": "2n",
                    "time": "3:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "B2",
                    "duration": "2n",
                    "time": "3:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D3",
                    "duration": "2n",
                    "time": "4:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "F#3",
                    "duration": "2n",
                    "time": "4:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "A3",
                    "duration": "2n",
                    "time": "4:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "22:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "A3",
                    "duration": "2n",
                    "time": "22:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "B3",
                    "duration": "2n",
                    "time": "23:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D3",
                    "duration": "2n",
                    "time": "23:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "F#3",
                    "duration": "2n",
                    "time": "24:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "24:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "A3",
                    "duration": "2n",
                    "time": "25:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "F#3",
                    "duration": "2n",
                    "time": "25:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "26:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "A3",
                    "duration": "2n",
                    "time": "26:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "B3",
                    "duration": "2n",
                    "time": "27:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "27:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "38:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "C3",
                    "duration": "4n",
                    "time": "38:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "38:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "38:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "38:3:3",
                    "velocity": 0.27
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "39:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "39:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "39:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "39:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "40:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "40:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "40:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "40:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "41:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "41:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "41:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "41:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "42:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "C3",
                    "duration": "4n",
                    "time": "42:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "42:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "42:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "42:3:3",
                    "velocity": 0.27
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "43:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "43:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "43:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "43:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "44:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "44:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "44:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "44:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "45:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "45:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "71:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "C3",
                    "duration": "4n",
                    "time": "71:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "71:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "71:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "71:3:3",
                    "velocity": 0.27
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "72:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "72:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "72:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "72:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "73:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "73:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "73:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "73:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "74:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "74:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "74:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "74:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "75:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "C3",
                    "duration": "4n",
                    "time": "75:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "75:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "75:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "75:3:3",
                    "velocity": 0.27
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "76:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "76:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "76:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "76:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "77:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "77:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "77:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "77:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "78:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "78:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "78:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "79:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "C3",
                    "duration": "4n",
                    "time": "79:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "79:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "79:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "79:3:3",
                    "velocity": 0.27
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "80:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "80:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "80:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "80:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "81:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "81:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "81:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "81:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "82:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "82:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "82:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "82:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "83:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "C3",
                    "duration": "4n",
                    "time": "83:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "83:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "83:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "83:3:3",
                    "velocity": 0.27
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "84:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "84:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "84:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "84:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "85:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "85:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "85:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "85:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "86:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "86:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "86:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "90:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "E3",
                    "duration": "2n",
                    "time": "90:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "C3",
                    "duration": "2n",
                    "time": "90:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "90:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D3",
                    "duration": "2n",
                    "time": "90:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "B2",
                    "duration": "2n",
                    "time": "90:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D3",
                    "duration": "2n",
                    "time": "91:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "F#3",
                    "duration": "2n",
                    "time": "91:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "A3",
                    "duration": "2n",
                    "time": "91:2:0",
                    "velocity": 0.27
                }
            ]
        },
        {
            "name": "EDM Kit (E)",
            "notes": [
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "5:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "5:3:1",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "6:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "6:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "6:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "6:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "7:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "7:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "7:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "7:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "8:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "8:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "8:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "8:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "9:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "9:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "9:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "9:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "9:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "10:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "10:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "10:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "10:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "11:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "11:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "11:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "11:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "12:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "12:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "12:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "12:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "13:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "13:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "13:1:1",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "13:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "13:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "14:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "14:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "14:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "15:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "15:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "15:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "15:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "16:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "16:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "16:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "16:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "17:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "17:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "17:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "17:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "18:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "19:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "19:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "20:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "20:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "21:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "21:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:0:1",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:0:3",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:2:1",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:2:3",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:0:1",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:0:3",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:2:1",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:2:3",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:3:1",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:3:3",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "28:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "28:0:1",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "28:0:3",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "28:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "28:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "28:2:1",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "28:2:3",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "28:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "28:3:3",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "29:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "29:0:1",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "29:0:3",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "29:1:1",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "29:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "30:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "30:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "30:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "30:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "31:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "31:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "31:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "31:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "32:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "32:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "32:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "32:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "33:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "33:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "33:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "33:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "34:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "34:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "34:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "35:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "35:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "35:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "35:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "36:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "36:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "36:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "36:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "37:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "37:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "37:1:1",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "37:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "37:2:1",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "37:2:3",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "37:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "38:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "38:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "38:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "39:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "39:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "39:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "40:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "40:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "40:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "41:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "41:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "41:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "41:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "42:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "42:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "42:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "42:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "43:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "43:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "43:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "43:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "44:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "44:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "44:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "44:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "45:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "45:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "63:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "63:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "63:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "63:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "64:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "64:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "64:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "64:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "65:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "65:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "65:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "65:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "66:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "66:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "66:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "66:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "67:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "67:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "67:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "67:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "68:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "68:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "68:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "68:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "69:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "69:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "69:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "69:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "70:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "70:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "70:1:1",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "70:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "70:2:1",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "70:2:3",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "70:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "71:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "71:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "71:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "71:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "72:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "72:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "72:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "72:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "73:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "73:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "73:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "73:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "74:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "74:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "74:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "74:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "75:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "75:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "75:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "75:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "76:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "76:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "76:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "76:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "77:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "77:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "77:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "77:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "78:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "78:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "78:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "78:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "79:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "79:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "79:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "79:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "80:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "80:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "80:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "80:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "81:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "81:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "81:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "81:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "82:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "82:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "82:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "82:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "83:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "83:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "83:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "83:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "84:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "84:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "84:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "84:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "85:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "85:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "85:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "85:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "86:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "86:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "86:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "86:3:0",
                    "velocity": 0.27
                }
            ]
        },
        {
            "name": "8-Bit Square",
            "notes": [
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "6:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "6:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "6:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "6:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "6:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "6:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "6:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "6:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "6:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "6:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "6:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "6:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "7:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "7:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "7:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "7:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "7:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "7:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "7:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "7:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "7:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "7:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "7:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "7:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "8:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "8:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "8:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "8:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "8:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "8:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "8:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "8:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "8:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "8:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "8:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "8:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "9:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "9:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "9:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "9:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "9:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "9:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "9:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "9:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "9:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "9:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "9:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "9:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "10:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "10:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "10:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "10:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "10:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "10:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "10:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "10:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "10:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "10:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "10:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "10:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "11:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "11:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "11:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "11:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "11:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "11:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "11:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "11:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "11:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "11:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "11:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "11:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "12:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "12:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "12:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "12:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "12:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "12:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "12:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "12:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "12:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "12:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "12:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "12:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "13:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "13:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "13:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "13:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "13:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "13:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "13:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "13:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "13:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "13:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "13:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "13:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "14:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "14:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "14:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "14:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "14:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "14:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "14:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "14:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "14:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "14:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "14:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "14:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "14:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "14:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "14:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "14:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "14:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "14:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "14:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "14:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "14:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "14:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "15:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "15:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "15:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "15:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "15:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "15:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "15:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "15:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "15:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "15:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "15:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "15:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "15:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "15:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "15:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "15:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "15:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "15:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "15:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "15:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "15:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "15:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "15:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "15:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "16:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "16:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "16:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "16:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "16:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "16:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "16:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "16:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "16:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "16:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "16:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "16:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "16:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "16:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "16:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "16:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "16:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "16:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "16:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "16:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "16:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "16:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "16:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "16:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "17:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "17:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "17:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "17:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "17:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "17:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "17:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "17:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "17:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "17:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "17:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "17:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "17:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "17:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "17:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "17:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "17:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "17:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "17:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "17:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "17:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "17:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "17:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "17:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "18:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "18:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "18:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "18:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "18:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "18:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "18:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "18:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "18:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "18:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "18:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "18:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "18:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "18:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "18:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "18:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "18:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "18:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "19:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "19:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "19:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "19:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "19:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "19:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "19:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "19:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "19:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "19:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "19:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "19:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "19:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "19:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "19:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "19:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "19:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "19:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "19:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "19:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "20:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "20:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "20:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "20:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "20:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "20:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "20:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "20:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "20:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "20:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "20:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "20:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "20:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "20:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "20:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "20:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "20:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "20:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "20:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "20:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "21:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "21:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "21:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "21:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "21:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "21:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "21:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "21:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "21:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "21:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "21:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "21:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "21:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "21:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "21:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "21:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "21:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "21:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "21:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "21:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "30:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "30:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "30:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "30:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "30:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "30:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "30:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "30:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "30:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "30:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "30:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "30:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "30:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "30:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "30:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "30:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "30:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "30:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "30:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "30:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "30:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "30:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "31:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "31:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "31:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "31:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "31:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "31:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "31:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "31:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "31:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "31:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "31:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "31:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "31:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "31:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "31:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "31:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "31:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "31:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "31:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "31:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "31:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "31:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "32:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "32:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "32:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "32:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "32:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "32:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "32:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "32:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "32:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "32:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "32:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "32:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "32:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "32:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "32:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "32:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "32:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "32:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "33:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "33:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "33:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "33:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "33:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "33:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "33:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "33:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "33:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "33:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "33:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "33:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "33:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "33:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "33:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "33:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "33:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "33:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "33:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "33:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "33:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "33:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "33:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "33:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "34:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "34:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "34:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "34:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "34:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "34:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "34:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "34:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "34:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "34:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "34:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "34:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "34:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "34:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "34:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "34:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "34:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "34:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "34:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "34:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "35:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "35:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "35:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "35:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "35:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "35:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "35:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "35:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "35:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "35:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "35:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "35:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "35:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "35:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "35:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "35:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "35:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "35:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "35:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "35:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "35:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "35:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "36:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "36:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "36:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "36:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "36:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "36:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "36:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "36:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "36:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "36:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "36:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "36:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "36:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "36:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "36:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "36:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "37:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "37:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "37:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "37:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "37:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "37:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "37:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "37:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "37:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "37:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "37:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "37:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "37:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "37:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "37:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "37:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "38:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "38:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "38:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "38:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "38:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "38:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "38:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "38:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "38:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "38:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "38:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "38:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "38:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "38:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "38:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "38:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "38:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "38:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "39:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "39:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "39:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "39:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "39:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "39:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "39:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "39:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "39:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "39:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "39:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "39:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "39:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "39:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "39:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "39:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "39:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "39:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "40:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "40:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "40:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "40:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "40:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "40:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "40:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "40:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "40:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "40:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "40:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "40:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "40:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "41:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "41:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "41:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "41:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "41:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "41:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "41:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "41:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "41:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "41:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "41:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "41:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "41:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "41:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "41:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "41:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "41:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "41:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "41:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "41:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "42:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "42:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "42:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "42:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "42:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "42:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "42:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "42:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "42:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "42:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "42:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "42:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "42:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "42:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "42:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "42:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "42:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "42:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "42:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "42:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "42:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "42:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "42:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "42:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "43:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "43:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "43:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "43:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "43:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "43:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "43:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "43:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "43:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "43:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "43:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "43:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "43:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "43:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "43:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "43:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "43:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "43:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "43:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "43:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "43:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "43:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "43:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "43:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "44:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "44:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "44:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "44:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "44:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "44:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "44:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "44:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "44:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "44:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "44:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "44:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "44:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "44:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "44:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "44:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "44:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "44:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "45:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "45:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "45:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "45:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "45:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "45:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "45:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "45:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "45:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "45:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "45:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "45:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "63:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "63:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "63:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "63:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "63:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "63:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "63:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "63:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "63:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "63:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "63:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "63:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "63:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "63:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "63:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "63:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "63:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "63:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "63:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "63:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "63:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "63:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "63:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "63:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "64:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "64:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "64:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "64:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "64:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "64:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "64:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "64:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "64:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "64:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "64:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "64:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "64:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "64:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "64:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "64:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "64:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "64:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "64:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "64:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "64:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "64:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "64:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "64:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "65:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "65:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "65:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "65:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "65:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "65:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "65:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "65:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "65:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "65:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "65:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "65:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "65:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "65:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "65:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "65:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "65:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "65:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "66:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "66:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "66:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "66:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "66:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "66:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "66:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "66:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "66:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "66:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "66:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "66:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "66:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "66:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "66:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "66:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "66:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "66:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "66:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "66:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "66:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "66:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "66:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "66:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "67:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "67:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "67:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "67:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "67:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "67:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "67:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "67:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "67:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "67:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "67:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "67:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "68:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "68:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "68:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "68:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "68:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "68:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "68:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "68:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "68:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "68:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "68:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "68:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "68:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "68:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "68:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "68:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "68:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "68:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "68:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "68:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "68:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "68:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "68:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "68:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "69:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "69:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "69:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "69:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "69:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "69:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "69:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "69:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "69:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "69:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "69:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "69:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "69:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "69:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "69:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "69:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "69:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "69:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "69:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "69:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "69:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "69:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "69:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "69:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "70:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "70:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "70:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "70:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "70:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "70:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "70:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "70:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "70:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "70:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "70:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "70:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "70:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "70:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "70:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "70:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "70:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "70:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "71:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "71:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "71:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "71:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "71:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "71:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "71:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "71:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "71:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "71:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "71:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "71:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "71:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "71:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "71:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "71:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "71:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "71:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "71:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "71:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "71:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "71:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "71:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "71:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "72:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "72:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "72:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "72:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "72:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "72:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "72:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "72:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "72:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "72:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "72:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "72:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "72:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "72:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "72:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "72:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "72:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "72:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "72:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "72:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "72:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "72:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "72:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "72:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "73:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "73:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "73:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "73:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "73:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "73:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "73:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "73:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "73:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "73:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "73:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "73:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "73:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "73:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "73:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "73:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "73:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "73:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "73:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "73:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "73:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "73:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "73:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "73:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "74:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "74:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "74:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "74:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "74:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "74:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "74:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "74:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "74:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "74:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "74:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "74:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "74:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "74:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "74:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "74:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "74:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "74:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "74:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "74:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "74:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "74:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "74:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "74:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "75:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "75:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "75:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "75:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "75:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "75:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "75:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "75:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "75:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "75:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "75:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "75:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "75:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "75:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "75:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "75:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "75:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "75:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "75:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "75:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "75:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "75:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "75:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "75:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "76:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "76:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "76:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "76:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "76:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "76:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "76:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "76:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "76:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "76:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "76:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "76:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "76:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "76:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "76:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "76:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "76:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "76:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "76:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "76:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "76:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "76:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "76:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "76:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "77:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "77:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "77:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "77:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "77:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "77:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "77:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "77:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "77:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "77:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "77:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "77:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "77:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "77:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "77:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "77:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "77:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "77:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "77:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "77:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "77:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "77:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "77:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "77:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "78:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "78:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "78:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "78:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "78:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "78:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "78:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "78:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "78:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "78:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "78:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "78:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "78:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "78:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "78:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "78:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "78:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "78:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "79:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "79:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "79:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "79:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "79:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "79:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "79:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "79:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "79:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "79:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "79:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "79:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "79:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "79:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "79:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "79:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "79:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "79:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "79:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "79:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "79:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "79:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "79:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "79:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "80:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "80:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "80:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "80:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "80:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "80:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "80:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "80:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "80:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "80:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "80:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "80:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "80:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "80:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "80:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "80:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "80:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "80:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "80:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "80:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "80:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "80:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "80:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "80:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "81:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "81:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "81:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "81:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "81:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "81:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "81:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "81:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "81:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "81:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "81:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "81:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "81:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "81:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "81:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "81:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "81:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "81:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "81:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "81:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "81:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "81:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "81:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "81:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "82:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "82:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "82:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "82:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "82:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "82:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "82:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "82:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "82:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "82:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "82:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "82:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "82:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "82:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "82:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "82:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "82:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "82:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "82:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "82:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "82:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "82:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "82:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "82:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "83:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "83:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "83:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "83:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "83:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "83:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "83:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "83:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "83:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "83:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "83:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "83:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "83:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "83:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "83:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "83:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "83:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "83:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "83:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "83:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "83:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "83:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "83:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "83:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "84:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "84:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "84:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "84:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "84:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "84:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "84:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "84:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "84:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "84:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "84:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "84:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "84:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "84:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "84:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "84:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "84:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "84:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "84:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "84:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "84:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "84:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "84:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "84:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "85:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "85:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "85:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "85:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "85:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "85:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "85:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "85:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "85:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "85:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "85:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "85:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "85:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "85:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "85:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "85:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "85:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "85:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "85:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "85:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "85:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "85:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "85:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "F#1",
                    "duration": "16n",
                    "time": "85:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "86:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "86:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "86:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "86:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "86:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "86:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "86:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "86:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "86:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "86:1:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "86:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "86:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "86:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "86:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "86:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "86:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "86:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "86:2:3",
                    "velocity": 0.31
                }
            ]
        },
        {
            "name": "Smooth Synth",
            "notes": [
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "6:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "6:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "6:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "7:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "7:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "7:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "8:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "8:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "8:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "9:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "9:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "9:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "10:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "10:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "10:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "11:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "11:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "11:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "12:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "12:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "12:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "12:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "12:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "12:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "13:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "13:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "13:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "22:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "2n",
                    "time": "23:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "2n",
                    "time": "23:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "1m",
                    "time": "24:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "1m",
                    "time": "25:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "26:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G1",
                    "duration": "2n",
                    "time": "27:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "2n",
                    "time": "27:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "1m",
                    "time": "28:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "30:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "1m",
                    "time": "31:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "2n",
                    "time": "32:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "2n",
                    "time": "32:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "1m",
                    "time": "33:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "34:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "1m",
                    "time": "35:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "2n",
                    "time": "36:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "2n",
                    "time": "36:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "2n",
                    "time": "37:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "38:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "1m",
                    "time": "39:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "2n",
                    "time": "40:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "2n",
                    "time": "40:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "1m",
                    "time": "41:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "42:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "1m",
                    "time": "43:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "2n",
                    "time": "44:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "2n",
                    "time": "44:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "2n",
                    "time": "45:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "1m",
                    "time": "55:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "1m",
                    "time": "56:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "B1",
                    "duration": "1m",
                    "time": "57:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "58:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "1m",
                    "time": "59:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "B1",
                    "duration": "1m",
                    "time": "60:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "61:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "1m",
                    "time": "62:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "63:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "1m",
                    "time": "64:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "2n",
                    "time": "65:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "2n",
                    "time": "65:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "1m",
                    "time": "66:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "67:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "1m",
                    "time": "68:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "2n",
                    "time": "69:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "2n",
                    "time": "69:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "2n",
                    "time": "70:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "71:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "1m",
                    "time": "72:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "2n",
                    "time": "73:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "2n",
                    "time": "73:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "1m",
                    "time": "74:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "75:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "1m",
                    "time": "76:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "2n",
                    "time": "77:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "2n",
                    "time": "77:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "1m",
                    "time": "78:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "79:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "1m",
                    "time": "80:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "2n",
                    "time": "81:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "2n",
                    "time": "81:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "1m",
                    "time": "82:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "83:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "D2",
                    "duration": "1m",
                    "time": "84:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G2",
                    "duration": "2n",
                    "time": "85:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#2",
                    "duration": "2n",
                    "time": "85:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E2",
                    "duration": "2n",
                    "time": "86:0:0",
                    "velocity": 0.31
                }
            ]
        },
        {
            "name": "2023 Drum Kit",
            "notes": [
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "9:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "G2",
                    "duration": "1m",
                    "time": "9:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "1m",
                    "time": "9:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G2",
                    "duration": "1m",
                    "time": "13:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "1m",
                    "time": "13:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "17:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "G2",
                    "duration": "1m",
                    "time": "17:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "1m",
                    "time": "17:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F2",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F2",
                    "duration": "16n",
                    "time": "21:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F2",
                    "duration": "16n",
                    "time": "21:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "21:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "21:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "21:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "21:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "21:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "4n",
                    "time": "21:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "2n",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "2n",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F2",
                    "duration": "16n",
                    "time": "45:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F2",
                    "duration": "16n",
                    "time": "45:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F2",
                    "duration": "16n",
                    "time": "45:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "45:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "45:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "45:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "2n",
                    "time": "46:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "2n",
                    "time": "63:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F2",
                    "duration": "16n",
                    "time": "70:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F2",
                    "duration": "16n",
                    "time": "70:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F2",
                    "duration": "16n",
                    "time": "70:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "70:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "70:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "70:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "70:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "70:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "70:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "4n",
                    "time": "70:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "2n",
                    "time": "71:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F2",
                    "duration": "16n",
                    "time": "78:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F2",
                    "duration": "16n",
                    "time": "78:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F2",
                    "duration": "16n",
                    "time": "78:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "78:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "78:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "78:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "78:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "78:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "78:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "4n",
                    "time": "78:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "2n",
                    "time": "79:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F2",
                    "duration": "16n",
                    "time": "86:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F2",
                    "duration": "16n",
                    "time": "86:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F2",
                    "duration": "16n",
                    "time": "86:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "86:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "86:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "86:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "86:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "86:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "86:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "4n",
                    "time": "86:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G2",
                    "duration": "1m",
                    "time": "86:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "1m",
                    "time": "86:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "1m",
                    "time": "86:3:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Grand Piano",
            "notes": [
                {
                    "name": "E4",
                    "duration": "1m",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "1m",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "15:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "1m",
                    "time": "15:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "1m",
                    "time": "15:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "15:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "1m",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "1m",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "1m",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "1m",
                    "time": "17:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "1m",
                    "time": "17:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "1m",
                    "time": "17:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "1m",
                    "time": "17:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "1m",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "1m",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "1m",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "1m",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "1m",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "1m",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "1m",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "1m",
                    "time": "21:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "1m",
                    "time": "21:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "1m",
                    "time": "21:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "1m",
                    "time": "21:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "1m",
                    "time": "47:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "1m",
                    "time": "47:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "47:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "1m",
                    "time": "47:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "48:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "1m",
                    "time": "48:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "1m",
                    "time": "48:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "48:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "49:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "1m",
                    "time": "49:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "1m",
                    "time": "49:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "49:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "1m",
                    "time": "50:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "1m",
                    "time": "50:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "50:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "1m",
                    "time": "50:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "51:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "1m",
                    "time": "51:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "51:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "51:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "52:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "1m",
                    "time": "52:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "1m",
                    "time": "52:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "1m",
                    "time": "52:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "53:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "1m",
                    "time": "53:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "1m",
                    "time": "53:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "53:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "1m",
                    "time": "54:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "1m",
                    "time": "54:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "54:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "1m",
                    "time": "54:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "1m",
                    "time": "55:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "1m",
                    "time": "55:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "55:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "1m",
                    "time": "55:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "1m",
                    "time": "55:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "1m",
                    "time": "56:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "56:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "1m",
                    "time": "56:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "1m",
                    "time": "56:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "56:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "1m",
                    "time": "57:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "57:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "1m",
                    "time": "57:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "1m",
                    "time": "57:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "57:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "1m",
                    "time": "58:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "1m",
                    "time": "58:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "58:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "1m",
                    "time": "58:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "58:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "1m",
                    "time": "59:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "1m",
                    "time": "59:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "59:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "1m",
                    "time": "59:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "1m",
                    "time": "59:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "1m",
                    "time": "60:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "60:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "1m",
                    "time": "60:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "1m",
                    "time": "60:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "60:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "1m",
                    "time": "61:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "1m",
                    "time": "61:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "1m",
                    "time": "61:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "61:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "61:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "1m",
                    "time": "62:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "62:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "1m",
                    "time": "62:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "1m",
                    "time": "62:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "62:0:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Flute",
            "notes": [
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "22:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "22:0:3",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "22:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "22:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "22:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "22:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "22:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "22:2:3",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "22:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "22:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "22:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "23:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "23:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "23:0:3",
                    "velocity": 0.24
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "23:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "23:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "23:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "23:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "23:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "23:2:3",
                    "velocity": 0.24
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "23:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "23:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "23:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "24:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "24:0:3",
                    "velocity": 0.24
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "24:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "24:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "24:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "24:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "24:2:3",
                    "velocity": 0.24
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "24:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "24:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "25:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "25:0:3",
                    "velocity": 0.24
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "25:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "25:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "25:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "25:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "25:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "25:2:3",
                    "velocity": 0.24
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "25:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "25:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "26:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "26:0:3",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "26:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "26:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "26:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "26:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "26:2:3",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "26:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "26:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "26:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "27:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "27:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "27:0:3",
                    "velocity": 0.24
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "27:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "27:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "27:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "27:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "27:2:3",
                    "velocity": 0.24
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "27:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "27:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "27:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "28:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "28:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "28:0:3",
                    "velocity": 0.24
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "28:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "28:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "28:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "28:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "28:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "28:2:3",
                    "velocity": 0.24
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "28:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "28:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "28:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "29:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "29:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "29:0:3",
                    "velocity": 0.24
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "29:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "29:1:3",
                    "velocity": 0.24
                }
            ]
        },
        {
            "name": "Electric Piano",
            "notes": [
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "7:1:3",
                    "velocity": 0.63
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "8:1:3",
                    "velocity": 0.63
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "9:2:0",
                    "velocity": 0.63
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "9:2:0",
                    "velocity": 0.63
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "9:2:3",
                    "velocity": 0.63
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "9:2:3",
                    "velocity": 0.63
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "9:3:1",
                    "velocity": 0.63
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "9:3:1",
                    "velocity": 0.63
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "11:1:3",
                    "velocity": 0.63
                },
                {
                    "name": "F#4",
                    "duration": "4n",
                    "time": "13:2:0",
                    "velocity": 0.63
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "13:3:0",
                    "velocity": 0.63
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "22:2:0",
                    "velocity": 0.63
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "22:3:0",
                    "velocity": 0.63
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "23:2:0",
                    "velocity": 0.63
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "23:3:0",
                    "velocity": 0.63
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "24:2:0",
                    "velocity": 0.63
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "24:3:0",
                    "velocity": 0.63
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "24:3:3",
                    "velocity": 0.63
                },
                {
                    "name": "F#4",
                    "duration": "2n",
                    "time": "25:0:0",
                    "velocity": 0.63
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "26:0:0",
                    "velocity": 0.63
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "26:1:0",
                    "velocity": 0.63
                },
                {
                    "name": "E4",
                    "duration": "2n",
                    "time": "26:2:0",
                    "velocity": 0.63
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "27:0:0",
                    "velocity": 0.63
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "27:1:0",
                    "velocity": 0.63
                },
                {
                    "name": "D4",
                    "duration": "2n",
                    "time": "27:2:0",
                    "velocity": 0.63
                }
            ]
        },
        {
            "name": "Zoey",
            "notes": [
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "13:3:1",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "13:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "14:0:3",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "14:1:3",
                    "velocity": 0.67
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "14:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "14:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "14:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "15:0:3",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "15:1:3",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "15:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "16:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "16:0:3",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "16:1:2",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "16:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "16:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "16:3:2",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "2n",
                    "time": "17:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "F#4",
                    "duration": "4n",
                    "time": "28:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "F#4",
                    "duration": "1m",
                    "time": "28:2:0",
                    "velocity": 0.67
                }
            ]
        },
        {
            "name": "Mira",
            "notes": [
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "17:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "17:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "17:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "18:0:3",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "18:1:3",
                    "velocity": 0.67
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "18:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "18:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "18:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "19:0:3",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "19:1:3",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "19:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "20:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "20:0:3",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "20:1:2",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "20:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "20:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "20:3:2",
                    "velocity": 0.67
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "21:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "21:0:3",
                    "velocity": 0.67
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "21:1:3",
                    "velocity": 0.67
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "21:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "21:2:1",
                    "velocity": 0.67
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "21:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "21:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "28:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "28:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "28:2:0",
                    "velocity": 0.67
                }
            ]
        },
        {
            "name": "8-Bit Triangle",
            "notes": [
                {
                    "name": "C3",
                    "duration": "1m",
                    "time": "30:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "30:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "30:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E3",
                    "duration": "1m",
                    "time": "30:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "31:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "1m",
                    "time": "31:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#3",
                    "duration": "1m",
                    "time": "31:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "31:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "2n",
                    "time": "32:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "32:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "32:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "1m",
                    "time": "32:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#4",
                    "duration": "2n",
                    "time": "32:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#3",
                    "duration": "2n",
                    "time": "32:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "1m",
                    "time": "33:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "33:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E3",
                    "duration": "1m",
                    "time": "33:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E4",
                    "duration": "1m",
                    "time": "33:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "C3",
                    "duration": "1m",
                    "time": "34:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "34:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "34:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E3",
                    "duration": "1m",
                    "time": "34:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "35:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "1m",
                    "time": "35:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#3",
                    "duration": "1m",
                    "time": "35:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "35:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "2n",
                    "time": "36:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "36:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "36:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "1m",
                    "time": "36:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#4",
                    "duration": "2n",
                    "time": "36:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#3",
                    "duration": "2n",
                    "time": "36:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "2n",
                    "time": "37:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "37:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E3",
                    "duration": "2n",
                    "time": "37:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E4",
                    "duration": "2n",
                    "time": "37:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "C3",
                    "duration": "1m",
                    "time": "38:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "38:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "38:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E3",
                    "duration": "1m",
                    "time": "38:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "39:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "1m",
                    "time": "39:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#3",
                    "duration": "1m",
                    "time": "39:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "39:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "2n",
                    "time": "40:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "40:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "40:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "1m",
                    "time": "40:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#4",
                    "duration": "2n",
                    "time": "40:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#3",
                    "duration": "2n",
                    "time": "40:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "1m",
                    "time": "41:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "41:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E3",
                    "duration": "1m",
                    "time": "41:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E4",
                    "duration": "1m",
                    "time": "41:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "C3",
                    "duration": "1m",
                    "time": "42:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "42:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "42:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E3",
                    "duration": "1m",
                    "time": "42:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "43:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "1m",
                    "time": "43:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#3",
                    "duration": "1m",
                    "time": "43:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "43:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "2n",
                    "time": "44:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "44:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "44:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "1m",
                    "time": "44:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#4",
                    "duration": "2n",
                    "time": "44:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#3",
                    "duration": "2n",
                    "time": "44:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "2n",
                    "time": "45:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "45:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E3",
                    "duration": "2n",
                    "time": "45:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E4",
                    "duration": "2n",
                    "time": "45:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "C3",
                    "duration": "1m",
                    "time": "63:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "63:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "63:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E3",
                    "duration": "1m",
                    "time": "63:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "64:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "1m",
                    "time": "64:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#3",
                    "duration": "1m",
                    "time": "64:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "64:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "2n",
                    "time": "65:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "65:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "65:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "1m",
                    "time": "65:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#4",
                    "duration": "2n",
                    "time": "65:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#3",
                    "duration": "2n",
                    "time": "65:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "1m",
                    "time": "66:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "66:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E3",
                    "duration": "1m",
                    "time": "66:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E4",
                    "duration": "1m",
                    "time": "66:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "C3",
                    "duration": "1m",
                    "time": "67:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "67:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "67:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E3",
                    "duration": "1m",
                    "time": "67:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "68:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "1m",
                    "time": "68:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#3",
                    "duration": "1m",
                    "time": "68:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "68:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "2n",
                    "time": "69:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "69:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "69:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "1m",
                    "time": "69:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#4",
                    "duration": "2n",
                    "time": "69:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#3",
                    "duration": "2n",
                    "time": "69:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "2n",
                    "time": "70:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "70:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E3",
                    "duration": "2n",
                    "time": "70:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E4",
                    "duration": "2n",
                    "time": "70:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "C3",
                    "duration": "1m",
                    "time": "71:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "71:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "71:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E3",
                    "duration": "1m",
                    "time": "71:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "72:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "1m",
                    "time": "72:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#3",
                    "duration": "1m",
                    "time": "72:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "72:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "2n",
                    "time": "73:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "73:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "73:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "1m",
                    "time": "73:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#4",
                    "duration": "2n",
                    "time": "73:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#3",
                    "duration": "2n",
                    "time": "73:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "1m",
                    "time": "74:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "74:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E3",
                    "duration": "1m",
                    "time": "74:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E4",
                    "duration": "1m",
                    "time": "74:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "C3",
                    "duration": "1m",
                    "time": "75:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "75:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "75:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E3",
                    "duration": "1m",
                    "time": "75:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "76:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "1m",
                    "time": "76:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#3",
                    "duration": "1m",
                    "time": "76:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "76:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "2n",
                    "time": "77:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "77:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "77:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "1m",
                    "time": "77:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#4",
                    "duration": "2n",
                    "time": "77:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#3",
                    "duration": "2n",
                    "time": "77:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "2n",
                    "time": "78:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "78:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E3",
                    "duration": "2n",
                    "time": "78:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E4",
                    "duration": "2n",
                    "time": "78:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "C3",
                    "duration": "1m",
                    "time": "79:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "79:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "79:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E3",
                    "duration": "1m",
                    "time": "79:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "80:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "1m",
                    "time": "80:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#3",
                    "duration": "1m",
                    "time": "80:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "80:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "2n",
                    "time": "81:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "81:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "81:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "1m",
                    "time": "81:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#4",
                    "duration": "2n",
                    "time": "81:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#3",
                    "duration": "2n",
                    "time": "81:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "1m",
                    "time": "82:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "82:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E3",
                    "duration": "1m",
                    "time": "82:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E4",
                    "duration": "1m",
                    "time": "82:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "C3",
                    "duration": "1m",
                    "time": "83:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "83:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "83:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E3",
                    "duration": "1m",
                    "time": "83:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "84:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "1m",
                    "time": "84:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#3",
                    "duration": "1m",
                    "time": "84:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "84:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "2n",
                    "time": "85:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "85:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "85:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "1m",
                    "time": "85:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#4",
                    "duration": "2n",
                    "time": "85:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#3",
                    "duration": "2n",
                    "time": "85:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "B3",
                    "duration": "2n",
                    "time": "86:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "86:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E3",
                    "duration": "2n",
                    "time": "86:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "E4",
                    "duration": "2n",
                    "time": "86:0:0",
                    "velocity": 0.24
                }
            ]
        },
        {
            "name": "Pop Synth",
            "notes": [
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "30:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "30:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "30:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "30:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "30:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "30:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "30:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "30:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "30:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "30:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "30:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "31:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "31:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "31:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "31:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "31:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "31:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "31:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "31:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "31:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "31:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "31:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "32:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "32:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "32:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "32:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "32:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "32:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "32:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "32:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "32:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "32:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "32:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "32:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "33:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "33:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "33:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "33:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "33:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "33:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "33:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "33:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "33:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "33:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "33:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "33:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "34:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "34:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "34:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "34:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "34:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "34:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "34:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "34:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "34:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "34:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "35:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "35:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "35:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "35:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "35:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "35:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "35:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "35:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "35:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "35:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "35:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "36:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "36:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "36:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "36:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "36:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "36:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "36:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "36:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "36:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "36:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "36:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "37:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "37:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "37:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "37:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "37:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "37:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "37:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "37:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "38:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "38:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "38:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "38:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "38:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "38:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "38:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "38:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "38:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "39:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "39:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "39:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "39:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "39:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "39:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "39:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "39:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "39:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "40:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "40:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "40:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "40:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "40:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "40:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "40:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "40:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "40:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "41:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "41:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "41:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "41:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "41:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "41:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "41:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "41:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "41:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "41:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "42:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "42:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "42:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "42:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "42:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "42:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "42:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "42:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "42:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "42:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "42:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "42:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "43:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "43:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "43:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "43:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "43:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "43:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "43:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "43:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "43:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "43:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "43:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "43:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "44:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "44:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "44:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "44:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "44:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "44:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "44:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "44:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "44:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "44:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "44:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "44:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "45:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "45:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "45:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "45:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "45:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "45:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "63:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "63:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "63:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "63:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "63:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "63:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "63:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "63:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "63:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "63:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "63:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "63:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "64:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "64:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "64:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "64:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "64:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "64:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "64:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "64:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "64:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "64:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "64:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "64:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "65:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "65:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "65:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "65:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "65:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "65:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "65:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "65:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "65:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "65:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "65:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "65:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "66:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "66:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "66:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "66:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "66:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "66:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "66:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "66:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "66:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "66:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "66:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "66:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "67:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "67:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "67:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "67:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "67:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "67:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "67:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "67:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "67:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "67:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "67:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "67:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "68:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "68:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "68:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "68:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "68:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "68:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "68:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "68:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "68:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "68:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "68:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "68:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "69:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "69:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "69:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "69:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "69:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "69:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "69:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "69:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "69:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "69:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "69:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "69:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "70:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "70:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "70:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "70:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "70:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "70:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "70:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "70:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "70:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "71:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "71:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "71:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "71:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "71:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "71:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "71:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "71:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "71:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "71:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "71:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "71:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "72:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "72:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "72:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "72:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "72:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "72:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "72:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "72:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "72:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "72:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "72:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "72:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "73:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "73:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "73:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "73:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "73:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "73:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "73:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "73:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "73:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "73:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "73:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "73:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "74:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "74:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "74:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "74:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "74:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "74:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "74:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "74:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "74:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "74:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "74:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "74:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "75:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "75:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "75:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "75:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "75:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "75:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "75:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "75:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "75:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "75:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "75:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "75:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "76:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "76:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "76:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "76:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "76:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "76:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "76:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "76:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "76:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "76:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "76:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "76:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "77:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "77:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "77:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "77:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "77:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "77:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "77:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "77:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "77:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "77:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "77:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "77:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "78:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "78:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "78:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "78:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "78:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "78:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "78:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "78:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "78:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "79:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "79:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "79:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "79:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "79:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "79:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "79:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "79:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "79:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "79:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "79:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "79:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "80:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "80:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "80:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "80:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "80:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "80:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "80:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "80:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "80:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "80:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "80:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "80:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "81:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "81:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "81:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "81:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "81:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "81:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "81:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "81:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "81:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "81:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "81:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "81:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "82:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "82:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "82:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "82:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "82:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "82:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "82:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "82:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "82:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "82:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "82:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "82:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "82:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "83:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "83:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "83:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "83:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "83:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "83:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "83:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "83:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "83:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "83:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "83:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "83:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "84:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "84:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "84:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "84:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "84:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "84:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "84:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "84:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "84:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "84:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "84:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "84:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "85:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "85:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "85:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "85:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "85:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "85:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "85:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "85:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "85:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "85:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "85:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "85:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "86:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "86:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "86:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "86:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "86:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "86:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "86:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "86:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "86:2:3",
                    "velocity": 0.2
                }
            ]
        },
        {
            "name": "Boom",
            "notes": [
                {
                    "name": "D2",
                    "duration": "2n",
                    "time": "45:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "1m",
                    "time": "46:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "1m",
                    "time": "92:1:0",
                    "velocity": 0.27
                }
            ]
        },
        {
            "name": "Strings",
            "notes": [
                {
                    "name": "G5",
                    "duration": "1m",
                    "time": "55:0:0",
                    "velocity": 0.02
                },
                {
                    "name": "F#5",
                    "duration": "1m",
                    "time": "56:0:0",
                    "velocity": 0.02
                },
                {
                    "name": "A5",
                    "duration": "1m",
                    "time": "57:0:0",
                    "velocity": 0.02
                },
                {
                    "name": "G5",
                    "duration": "1m",
                    "time": "58:0:0",
                    "velocity": 0.02
                },
                {
                    "name": "B6",
                    "duration": "1m",
                    "time": "59:0:0",
                    "velocity": 0.02
                },
                {
                    "name": "F#6",
                    "duration": "1m",
                    "time": "60:0:0",
                    "velocity": 0.02
                },
                {
                    "name": "G6",
                    "duration": "1m",
                    "time": "61:0:0",
                    "velocity": 0.02
                },
                {
                    "name": "A6",
                    "duration": "1m",
                    "time": "62:0:0",
                    "velocity": 0.02
                }
            ]
        },
        {
            "name": "Rumi",
            "notes": [
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "6:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "6:1:1",
                    "velocity": 0.67
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "6:1:3",
                    "velocity": 0.67
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "6:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "6:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "6:3:1",
                    "velocity": 0.67
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "6:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "7:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "7:3:1",
                    "velocity": 0.67
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "7:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "8:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "8:3:1",
                    "velocity": 0.67
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "8:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "9:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "9:0:3",
                    "velocity": 0.67
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "10:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "10:1:1",
                    "velocity": 0.67
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "10:1:3",
                    "velocity": 0.67
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "10:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "10:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "10:3:1",
                    "velocity": 0.67
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "10:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "11:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "11:3:1",
                    "velocity": 0.67
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "11:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "12:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "F#4",
                    "duration": "4n",
                    "time": "12:1:3",
                    "velocity": 0.67
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "12:3:1",
                    "velocity": 0.67
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "12:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "13:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "13:0:3",
                    "velocity": 0.67
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "13:1:1",
                    "velocity": 0.67
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "13:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "13:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "13:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "22:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "22:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "22:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "22:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "23:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "23:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "E5",
                    "duration": "4n",
                    "time": "23:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "23:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "F#4",
                    "duration": "4n",
                    "time": "24:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "24:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "24:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "24:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "24:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "2n",
                    "time": "25:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "F#4",
                    "duration": "4n",
                    "time": "25:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "26:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "26:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "26:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "26:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "27:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "27:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "E5",
                    "duration": "4n",
                    "time": "27:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "27:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "F#4",
                    "duration": "4n",
                    "time": "28:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "28:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "1m",
                    "time": "28:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "29:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "29:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "29:3:1",
                    "velocity": 0.67
                },
                {
                    "name": "E5",
                    "duration": "4n",
                    "time": "30:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "E5",
                    "duration": "4n",
                    "time": "30:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "30:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "30:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "30:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "30:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "31:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "31:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "31:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "31:2:1",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "31:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "31:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "31:3:1",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "31:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "32:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "32:0:3",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "32:1:3",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "32:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "32:2:1",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "32:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "32:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "32:3:1",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "32:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "33:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "33:0:3",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "33:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "33:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "33:3:1",
                    "velocity": 0.67
                },
                {
                    "name": "E5",
                    "duration": "4n",
                    "time": "34:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "E5",
                    "duration": "4n",
                    "time": "34:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "G5",
                    "duration": "8n",
                    "time": "34:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "F#5",
                    "duration": "16n",
                    "time": "34:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "34:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "34:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "35:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "35:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "35:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "35:2:1",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "35:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "35:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "35:3:1",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "35:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "36:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "36:0:3",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "36:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "36:2:1",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "36:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "36:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "36:3:1",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "36:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "37:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "37:0:3",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "37:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "37:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "37:3:1",
                    "velocity": 0.67
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "38:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "38:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "38:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "38:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "39:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "F#4",
                    "duration": "4n",
                    "time": "39:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "E5",
                    "duration": "4n",
                    "time": "39:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "39:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "40:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "40:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "A5",
                    "duration": "4n",
                    "time": "40:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "F#5",
                    "duration": "8n",
                    "time": "40:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "G5",
                    "duration": "4n",
                    "time": "40:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "E5",
                    "duration": "2n",
                    "time": "41:0:3",
                    "velocity": 0.67
                },
                {
                    "name": "F#4",
                    "duration": "4n",
                    "time": "41:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "42:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "42:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "42:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "42:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "43:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "F#4",
                    "duration": "4n",
                    "time": "43:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "E5",
                    "duration": "4n",
                    "time": "43:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "43:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "44:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "44:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "A5",
                    "duration": "4n",
                    "time": "44:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "F#5",
                    "duration": "8n",
                    "time": "44:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "G5",
                    "duration": "4n",
                    "time": "44:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "E5",
                    "duration": "4n",
                    "time": "45:0:3",
                    "velocity": 0.67
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "46:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "46:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "47:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "47:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "47:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "47:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "47:3:1",
                    "velocity": 0.67
                },
                {
                    "name": "F#4",
                    "duration": "4n",
                    "time": "48:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "48:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "48:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "48:3:2",
                    "velocity": 0.67
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "49:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "49:1:3",
                    "velocity": 0.67
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "49:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "49:2:1",
                    "velocity": 0.67
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "49:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "B3",
                    "duration": "2n",
                    "time": "50:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "50:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "50:3:2",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "51:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "51:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "51:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "51:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "51:3:1",
                    "velocity": 0.67
                },
                {
                    "name": "F#4",
                    "duration": "4n",
                    "time": "52:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "52:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "52:2:2",
                    "velocity": 0.67
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "52:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "52:3:2",
                    "velocity": 0.67
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "53:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "53:1:2",
                    "velocity": 0.67
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "53:1:3",
                    "velocity": 0.67
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "53:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "53:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "53:3:1",
                    "velocity": 0.67
                },
                {
                    "name": "B3",
                    "duration": "2n",
                    "time": "54:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "55:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "55:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "55:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "55:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "56:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "56:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "56:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "56:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "57:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "57:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "57:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "57:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "2n",
                    "time": "57:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "F#4",
                    "duration": "4n",
                    "time": "58:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "59:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "59:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "59:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "59:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "60:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "F#4",
                    "duration": "4n",
                    "time": "60:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "E5",
                    "duration": "4n",
                    "time": "60:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "60:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "61:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "61:1:1",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "61:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "61:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "2n",
                    "time": "61:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "G5",
                    "duration": "8n",
                    "time": "62:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "F#5",
                    "duration": "8n",
                    "time": "62:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "62:3:1",
                    "velocity": 0.67
                },
                {
                    "name": "E5",
                    "duration": "4n",
                    "time": "63:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "E5",
                    "duration": "4n",
                    "time": "63:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "63:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "63:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "63:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "63:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "64:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "64:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "64:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "64:2:1",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "64:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "64:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "64:3:1",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "64:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "65:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "65:0:3",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "65:1:3",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "65:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "65:2:1",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "65:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "65:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "65:3:1",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "65:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "66:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "66:0:3",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "66:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "66:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "66:3:1",
                    "velocity": 0.67
                },
                {
                    "name": "E5",
                    "duration": "4n",
                    "time": "67:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "E5",
                    "duration": "4n",
                    "time": "67:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "G5",
                    "duration": "8n",
                    "time": "67:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "F#5",
                    "duration": "16n",
                    "time": "67:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "67:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "67:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "68:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "68:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "68:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "68:2:1",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "68:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "68:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "68:3:1",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "68:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "69:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "69:0:3",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "69:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "69:2:1",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "69:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "69:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "69:3:1",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "69:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "70:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "70:0:3",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "70:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "70:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "70:3:1",
                    "velocity": 0.67
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "71:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "71:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "71:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "71:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "72:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "F#4",
                    "duration": "4n",
                    "time": "72:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "E5",
                    "duration": "4n",
                    "time": "72:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "72:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "73:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "73:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "A5",
                    "duration": "4n",
                    "time": "73:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "F#5",
                    "duration": "8n",
                    "time": "73:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "G5",
                    "duration": "4n",
                    "time": "73:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "E5",
                    "duration": "2n",
                    "time": "74:0:3",
                    "velocity": 0.67
                },
                {
                    "name": "F#4",
                    "duration": "4n",
                    "time": "74:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "75:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "75:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "75:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "75:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "76:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "F#4",
                    "duration": "4n",
                    "time": "76:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "E5",
                    "duration": "4n",
                    "time": "76:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "76:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "77:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "77:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "A5",
                    "duration": "4n",
                    "time": "77:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "F#5",
                    "duration": "8n",
                    "time": "77:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "G5",
                    "duration": "4n",
                    "time": "77:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "E5",
                    "duration": "4n",
                    "time": "78:0:3",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "78:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "78:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "78:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "79:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "79:0:1",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "79:0:3",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "79:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "79:1:1",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "79:1:3",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "79:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "79:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "79:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "80:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "80:0:1",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "80:0:3",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "80:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "80:1:1",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "80:1:3",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "80:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "81:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "81:0:1",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "81:0:3",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "81:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "81:1:1",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "81:1:3",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "81:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "81:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "81:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "82:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "82:0:1",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "82:0:3",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "82:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "82:1:1",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "82:1:3",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "82:2:3",
                    "velocity": 0.67
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "82:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "82:3:3",
                    "velocity": 0.67
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "83:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "83:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "83:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "83:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "84:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "F#4",
                    "duration": "4n",
                    "time": "84:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "E5",
                    "duration": "4n",
                    "time": "84:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "84:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "85:0:0",
                    "velocity": 0.67
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "85:1:0",
                    "velocity": 0.67
                },
                {
                    "name": "A5",
                    "duration": "4n",
                    "time": "85:2:0",
                    "velocity": 0.67
                },
                {
                    "name": "F#5",
                    "duration": "8n",
                    "time": "85:3:0",
                    "velocity": 0.67
                },
                {
                    "name": "G5",
                    "duration": "2n",
                    "time": "85:3:3",
                    "velocity": 0.67
                }
            ]
        }
    ],
    structure: [
        { type: 'INTRO', duration: 16, rhythm: 'MINIMAL', lyrics: ["(Golden...)", "It's time to shine...", "Listen up."] },
        { type: 'VERSE', duration: 32, rhythm: 'HOUSE', lyrics: ["I was a ghost, I was alone", "Eoduwojin apgil soge (In the dark path)", "I was the queen that I'm meant to be", "But now I see the light in me"] },
        { type: 'PRE_CHORUS', duration: 16, rhythm: 'BUILDUP', lyrics: ["I'm done hidin', now I'm shinin'", "Can you feel the rush?", "Now I believe"] },
        { type: 'CHORUS', duration: 32, rhythm: 'ANTHEM', lyrics: ["We're goin' up, up, up", "Gonna be, gonna be GOLDEN!", "Yeongwonhi kkaejil su eomneun (Unbreakable forever)", "We are the stars tonight!"] },
        { type: 'DROP', duration: 16, rhythm: 'ANTHEM', lyrics: ["(GOLDEN!)", "Hey! Hey!", "(GOLDEN!)"] },
        { type: 'VERSE', duration: 32, rhythm: 'HOUSE', lyrics: ["Back on the throne, I'm not alone", "Look at the diamonds on my bone", "We glitter like we're made of stone", "Can't break us, no, we're fully grown"] },
        { type: 'PRE_CHORUS', duration: 16, rhythm: 'BUILDUP', lyrics: ["I'm done hidin', now I'm shinin'", "Can you feel the rush?", "Now I believe"] },
        { type: 'CHORUS', duration: 32, rhythm: 'ANTHEM', lyrics: ["We're goin' up, up, up", "Gonna be, gonna be GOLDEN!", "Higher than we've ever been", "We are the stars tonight!"] },
        { type: 'BRIDGE', duration: 16, rhythm: 'MINIMAL', lyrics: ["Shining brighter than the sun", "We've only just begun", "Watch us overcome", "We are the Golden ones!"] },
        { type: 'CHORUS', duration: 32, rhythm: 'ANTHEM', lyrics: ["We're goin' up, up, up", "Gonna be, gonna be GOLDEN!", "Yeongwonhi kkaejil su eomneun", "We are the stars tonight!"] },
        { type: 'OUTRO', duration: 16, rhythm: 'MINIMAL', lyrics: ["Yeah, we are Golden...", "Forever.", "Golden."] }
    ],
    musicalData: {
        keyRoot: "E", 
        scale: "major", 
        bpm: 128,
        defaultTheme: {
            chordProgression: [0, 4, 5, 3],
            bassPattern: [1, 0, 0, 0, 1, 0, 0, 0],
            melodyPattern: [0, 2, 4, 7, 4, 2, 0, null]
        },
        themes: {
            INTRO: {
                chordProgression: [0, 0, 3, 3],
                bassPattern: [1, 0, 0, 0, 0, 0, 0, 0],
                melodyPattern: [0, 4, 7, 12, 7, 4, 0, 4, 7, 12, 14, 12, 7, 4, 0, null]
            },
            VERSE: {
                chordProgression: [0, 4], 
                bassPattern: [1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0], 
                melodyPattern: [4, 4, 2, 2, 0, 0, null, null, 4, 4, 2, 2, 0, 0, null, null]
            },
            PRE_CHORUS: {
                chordProgression: [3, 4, 5, 4],
                bassPattern: [1, 1, 1, 1, 1, 1, 1, 1], 
                melodyPattern: [7, 7, 7, 7, 9, 9, 9, 9, 11, 11, 11, 11, 12, 12, 14, 14]
            },
            CHORUS: {
                chordProgression: [3, 0, 4, 1], 
                bassPattern: [1, 0, 0, 1, 0, 0, 1, 0, 1, 1, 1, 1, 0, 0, 1, 0], 
                melodyPattern: [7, 7, 12, 12, 12, null, 9, 9, 7, 7, 4, 4, 7, 7, 7, 7]
            },
            DROP: {
                chordProgression: [0, 3, 5, 4],
                bassPattern: [1, 0, 1, 0, 1, 0, 1, 1],
                melodyPattern: [12, null, 12, null, 14, 12, 11, 9, 7, 7, 4, 4, 7, 9, 12, 14]
            },
            BRIDGE: {
                chordProgression: [5, 4, 3, 4], 
                bassPattern: [1, 0, 0, 0, 1, 0, 0, 0], 
                melodyPattern: [12, 11, 9, 7, 5, 4, 2, 0, 2, 4, 5, 7, 9, 11, 12, 14]
            }
        }
    }
};
